import $ from 'jquery';
import 'slick-carousel';
import MicroModal from 'micromodal';

const galleryGroup = 'trims-gallery-slider';

$(`.${galleryGroup}`).each(function () {
  const id = $(this).data('modal');
  const galleryID = `${galleryGroup}-${id}`;

  const $trimsGallerySlider = $(`.${galleryID}`);

  $trimsGallerySlider.on('init reInit afterChange', function (event, slick, currentSlide) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $(`.controls-dots-${galleryID}`).data('theme');
      dots.addClass('slick-dot ' + theme);
    }
  });

  $trimsGallerySlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: true,
    appendDots: $(`.controls-dots-${galleryID}`),
    nextArrow: $(`.controls-next-${galleryID}`),
    prevArrow: $(`.controls-prev-${galleryID}`),
  });
});

$('.js-open-modal').on('click', function () {
  const modalID = $(this).data('modal');
  MicroModal.show(`modal-${modalID}`);
});

$('.collection-slider').each(function () {
  const sliderID = $(this).data('slider');

  const $configureGallerySlider = $(`.${sliderID}`);

  $configureGallerySlider.on('init', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $(`.controls-dots-${sliderID}`).data('theme');
      dots.addClass('slick-dot ' + theme);
    }
  });

  $configureGallerySlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: true,
    appendDots: $(`.controls-dots-${sliderID}`),
    nextArrow: $(`.controls-next-${sliderID}`),
    prevArrow: $(`.controls-prev-${sliderID}`),
  });

  $configureGallerySlider.on('setPosition', function (e, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });
});

$('.summary-slider').each(function () {
  const sliderID = $(this).data('slider');

  const $configureGallerySlider = $(`.${sliderID}`);

  $configureGallerySlider.on('init', function (event, slick) {
    if (slick.$dots) {
      const dots = slick.$dots.find('li');
      const theme = $(`.controls-dots-${sliderID}`).data('theme');
      dots.addClass('slick-dot ' + theme);
    }
  });

  $configureGallerySlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: true,
    appendDots: $(`.controls-dots-${sliderID}`),
    nextArrow: $(`.controls-next-${sliderID}`),
    prevArrow: $(`.controls-prev-${sliderID}`),
  });

  $configureGallerySlider.on('setPosition', function (e, slick) {
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');
  });
});
